import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import EthernetExpansionBoard from '../../../Image/EthernetExpansionBoard.png';

/**
 * BntEthernet component renders a button that opens a dialog with Ethernet Expansion Board information.
 * 
 * @component
 */
const BntEthernet = () => {
    const [open, setOpen] = useState(false);
  
    /**
     * Handles the click event to open the Ethernet Expansion Board dialog.
     */
    const handleClickOpen = () => {
      setOpen(true);
    };
  
    /**
     * Handles the close event to close the Ethernet Expansion Board dialog.
     */
    const handleClose = () => {
      setOpen(false);
    };
  
    return (
      <div>
        <Button
          size="small"
          onClick={handleClickOpen}
          sx={{ textTransform: 'none' }} // Removes caps lock
        >
          More Info
        </Button>
  
        <Dialog 
          open={open} 
          onClose={handleClose} 
          fullWidth 
          maxWidth="md"
          sx={{ 
            '& .MuiDialog-paper': {
              overflow: 'hidden', // Removes scrolling
              width: '100%', // Ajusts the width of the dialog
            }
          }}
        >
          <DialogTitle sx={{ fontWeight: 'bold', fontFamily: 'Open Sans',justifyContent: 'center', alignItems: 'center', display: 'flex', fontSize: '24px'}}>
            Ethernet Expansion Board
          </DialogTitle>
          <DialogContent sx={{ padding: 0, overflow: 'hidden' }}>
            <div style={{ display: 'flex', alignItems: 'flex-start', width: '100%' }}>
              <div style={{ flex: '0 0 60%', paddingRight: '20px', boxSizing: 'border-box', marginLeft:'5%', marginTop:'6%',fontFamily: 'Open Sans'}}>
                <Typography sx={{ fontSize: '18px',
                  fontFamily: 'Open Sans',
                  textAlign: 'left', // Aligns to the left
                  margin: 0, // Removes margins
                  overflow: 'hidden', // Removes scrolling
                  whiteSpace: 'nowrap', // Avoids line break
                  textOverflow: 'ellipsis' // Adds '...' for long text
                }}>
                  Extend the number of ethernet interfaces in the front panel.
                  <br />
                  <br />
                  •  4x1 Gbps Ethernet ports
                  <br />
                  • TCP/IP, UDP, CCSDS Space Link Extension (SLE)
                  <br />
                  • Precision Time Protocol (PTP) IEEE 1588
                  <br />
                  • Built-in network switch
                  <br />
                  •  ADHA Peripheral slot
                </Typography>
              </div>
              <div style={{ flex: '1 0 40%', boxSizing: 'border-box' }}>
                <img
                  src={EthernetExpansionBoard}
                  alt="Imagem Descritiva"
                  style={{ width: '150%', height: '120%', marginLeft:'-50%' }} // Ajusts image width
                />
              </div>
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Close</Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  };
  
  /**
   * Exports the BntEthernet component as the default export.
   */
  export default BntEthernet;